import {Summary, SummaryCounts, SummaryRequestParams} from '@entities/summary/types';
import api from '@shared/api';

const PATH = 'invoice-api/api/v2/invoices';
export const fetch = async (params: SummaryRequestParams) =>
    (await api.post<Summary>(`${PATH}/summary`, null, {params})).data;

export const fetchCounts = async (params: SummaryRequestParams) =>
    (await api.post<SummaryCounts>(`${PATH}/partners_count`, null, {params})).data;
